import { loadStripe, Stripe } from "@stripe/stripe-js";

interface IStripeService {
  getStripePromise: () => Promise<Stripe | null>,
  handleCardAction: (clientSecret: string) => Promise<void>,
}

class StripeService {
  static sharedInstance: IStripeService;
  static shared() {
    if (!this.sharedInstance) {
      this.sharedInstance = new StripeService();
    }
    return this.sharedInstance;
  }
  private stripeInstance: Stripe | null = null;

  public getStripePromise(): Promise<Stripe | null> {
    return new Promise(async (resolve, reject) => {
      try {
        if (this.stripeInstance) {
          return resolve(this.stripeInstance);
        }
        const stripe = await loadStripe(process.env.NEXT_PUBLIC_STRIPE_PUBLISHABLE_KEY!);
        this.stripeInstance = stripe;
        resolve(stripe);
      } catch (error) {
        reject(error);
      }
    });
  }

  public handleCardAction(clientSecret: string): Promise<void> {
    return new Promise(async (resolve, reject) => {
      try {
        const stripe = await this.getStripePromise();
        const result = await stripe?.confirmCardPayment(clientSecret);
        if (result?.error) {
          reject(result.error);
          return;
        }
        resolve();
      } catch (error) {
        reject(error);
      }
    });
  }
}

export default StripeService;
